import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=373959ec&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "../styles/profile/index.scss?vue&type=style&index=0&id=373959ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373959ec",
  null
  
)

export default component.exports